import Request from './request'
import { sevH5lblUrl } from '@/config'
const LBL_BASE_URL = process.env.NODE_ENV === 'production' ? '' : '/lblapi'

export const getApk = async requestData => {
  return await Request({
    title: '获取app版本包',
    url: LBL_BASE_URL + '/rest/app/community/version/getDetail',
    data: requestData
  })
}
export const messageDetail = async requestData => {
  return await Request({
    title: '获取消息详情',
    url: LBL_BASE_URL + '/rest/app/community/message/getMessageDetail',
    app: 'lbl',
    data: requestData
  })
}
export const readMessage = async requestData => {
  return await Request({
    title: '批量已读消息',
    url: LBL_BASE_URL + '/rest/app/community/message/readMessage',
    app: 'lbl',
    data: requestData
  })
}

export const getMessageImgUrl = async requestData => {
  return await Request({
    title: '获取消息图片地址',
    url: LBL_BASE_URL + '/rest/app/community/message/getImgUrl',
    app: 'lbl',
    data: requestData
  })
}

export const marketingDetail = async requestData => {
  return await Request({
    title: '获取地产营销详情',
    url: LBL_BASE_URL + '/rest/app/community/marketing/getDetail',
    app: 'lbl',
    data: requestData
  })
}

export const guideDetail = async requestData => {
  return await Request({
    title: '获取社区指南详情',
    url: LBL_BASE_URL + '/rest/app/community/guide/getDetail',
    app: 'lbl',
    data: requestData
  })
}

export const announceGet = async requestData => {
  return await Request({
    title: '获取社区公告详情',
    url: LBL_BASE_URL + '/rest/app/community/announce/get',
    app: 'lbl',
    data: requestData
  })
}

export const articleManageGet = async requestData => {
  return await Request({
    title: '获取文章管理详情',
    url: LBL_BASE_URL + '/rest/life/article/getArticeDetail',
    app: 'lbl',
    data: requestData
  })
}

export const voteList = async requestData => {
  return await Request({
    title: '获取投票列表',
    url: LBL_BASE_URL + '/rest/app/community/vote/list',
    app: 'lbl',
    data: requestData
  })
}

export const voteDetail = async requestData => {
  return await Request({
    title: '获取投票详情',
    url: LBL_BASE_URL + '/rest/app/community/vote/detail',
    app: 'lbl',
    data: requestData
  })
}

export const voteWrite = async requestData => {
  return await Request({
    title: '填写投票',
    url: LBL_BASE_URL + '/rest/app/community/vote/write',
    app: 'lbl',
    data: requestData
  })
}

export const questionnnaireList = async requestData => {
  return await Request({
    title: '获取问卷调查列表',
    url: LBL_BASE_URL + '/rest/app/community/questionnaire/list',
    app: 'lbl',
    data: requestData
  })
}

export const questionnaireDetail = async requestData => {
  return await Request({
    title: '获取问卷详情',
    url: LBL_BASE_URL + '/rest/app/community/questionnaire/details',
    app: 'lbl',
    data: requestData
  })
}

export const questionnaireWrite = async requestData => {
  return await Request({
    title: '填写问卷',
    url: LBL_BASE_URL + '/rest/app/community/questionnaire/write',
    app: 'lbl',
    data: requestData
  })
}
export const helpCenterList = async requestData => {
  return await Request({
    title: '帮助中心-列表',
    url: LBL_BASE_URL + '/rest/life/helpCenter/list',
    app: 'lbl',
    data: requestData
  })
}
export const helpProblemList = async requestData => {
  return await Request({
    title: '帮助中心-分类问题页',
    url: LBL_BASE_URL + '/rest/life/helpCenter/problemList',
    app: 'lbl',
    data: requestData
  })
}
export const helpProblemDetail = async requestData => {
  return await Request({
    title: '帮助中心-问题详情',
    url: LBL_BASE_URL + '/rest/life/helpCenter/problemDetail',
    app: 'lbl',
    data: requestData
  })
}
export const helpProblemFeedback = async requestData => {
  return await Request({
    title: '帮助中心-问题解决情况反馈',
    url: LBL_BASE_URL + '/rest/life/helpCenter/problemFeedback',
    app: 'lbl',
    data: requestData
  })
}
export const getTwitterDetail = async requestData => {
  return await Request({
    title: '获取动态详情',
    url: LBL_BASE_URL + '/rest/life/twitter/detail',
    data: requestData
  })
}
export const commentTwitterList = async requestData => {
  return await Request({
    title: '动态详情评论接口',
    url: LBL_BASE_URL + '/rest/life/twitter/commentTwitterList',
    data: requestData
  })
}
export const getCircleDetail = async requestData => {
  return await Request({
    title: '获取圈子详情',
    url: LBL_BASE_URL + '/rest/life/twitter/circleDetail',
    data: requestData,
    //要加请求头phone，手机号任意，才能请求成功
    headers: {
      phone: '111'
    }
  })
}
export const getTwitterList = async requestData => {
  return await Request({
    title: '获取动态列表',
    url: LBL_BASE_URL + '/rest/life/twitter/circleTwitterList',
    data: requestData
  })
}
export const appLogin = async requestData => {
  return await Request({
    title: 'app登录(service[服务售后项目])',
    method: 'post',
    app: 'lbl',
    url: sevH5lblUrl + '/rest/app/community/shop/login',
    data: requestData,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
